import Nav from 'components/nav2';
import { _T } from '@dana/components';
import './privacy.css';
import { useState } from 'react';

export default function UserAgreement() {
  const [h, setH] = useState(0);

  return (
    <div className="overflow-scroll h-screen pt-[30px]">
      <Nav close={true} title={_T('隐私协议')}></Nav>
      <div className="privacy-policy">
        {/* <div className="head-title text-r"><span className="date-text"><strong>Release Date: June 28, 2024</strong></span>
            </div>
            <div className="head-title text-r"><span className="date-text"><strong>Effective Date: July 1, 2024</strong></span>
            </div> */}
          <div className="head-title tips">
        <span>
          <strong>{_T('提示信息' )}</strong>
        </span>
      </div>
      <div className="head-title content-text">
        {_T('Dana平台经营者（下称“我们”）非常重视用户的隐私和个人信息保护，也感谢您对我们的信任。我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控，为您提供合理高效的隐私保护。鉴于此，我们制定本《隐私政策》（下称“本政策/本隐私政策”），向您说明我们会如何收集、使用、存储、保护及对外提供您的信息，并说明您享有的权利。' )}
      </div>
      <div className="head-title content-text">
        {_T('本政策适用于由SYNCINGPTE.LTD.开发和运营的Dana平台，也同时适用于由SYNCINGPTE.LTD.及其关联公司开发和运营其他互联网产品，但其他产品中独立设定隐私政策并对收集、使用、存储、保护用户信息作出不同于本政策规定的，适用其规定。Dana平台禁止14周岁以下儿童注册或使用，未满14周岁的儿童的个人信息同时适用本政策以及《儿童隐私保护声明》。本隐私政策不适用于其他独立方式向您提供的服务，也不适用于Dana平台中已另行独立设定法律声明及隐私政策的产品或服务。当我们平台上的第三方依托我们平台向您提供服务时，您向第三方提供的个人信息不适用于本隐私政策。' )}
      </div>
      <div className="head-title content-text">
        {_T('当您在APP房间内时，为确保您能及时接收房间消息并便捷返回房间，我们会启用前台保活功能。此时，APP会在手机通知栏显示相关通知，点击即可跳转回房间，期间我们仅处理维持房间连接与消息推送所需的最少数据，且不会泄露您的隐私信息 。' )}
      </div>
      <div className="head-title content-text">
        {_T('在使用我们的产品或服务前，请您务必仔细阅读并充分理解本隐私政策，特别是以粗体标识的条款，可能涉及您的重要权利，您应重点阅读，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用我们提供的产品或服务，即表示您已充分理解并同意我们在本政策中所述内容。' )}
      </div>
      <div className="head-title tips">
        <span>
          <strong>{_T('第一部分 定义' )}</strong>
        </span>
      </div>
      <div className="head-title content-text">
        {_T('Dana平台：指Dana网站（Dana.chat）及客户端。' )}
      </div>
      <div className="head-title content-text">
        {_T('Dana平台服务：Dana平台经营者基于互联网，以包含Dana平台网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。用户如登录或使用Dana平台经营者关联公司的产品或服务，且该关联产品或服务未设独立用户服务协议及隐私政策的，则本隐私政策同样适用于该部分产品或服务。' )}
      </div>
      <div className="head-title content-text">
        {_T('Dana平台经营者：SYNCING PTE.LTD.及其关联方。' )}
      </div>
      <div className="head-title content-text">
        {_T('用户：下称“您”或“用户”，是指注册、登录、使用、浏览、获取本协议项下服务的个人或组织。' )}
      </div>
      <div className="head-title content-text">
        {_T('个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括自然人姓名、出生日期、身份证件信息、个人生物识别信息、住址、电话号码等。' )}
      </div>
      <div className="head-title content-text">
        {_T('个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息，包括身份证件信息、个人生物识别信息、银行账户、财产信息、行踪轨迹、通信内容、14岁以下（含）儿童信息、健康生理信息等信息。（我们将在本隐私政策中对具体个人敏感信息以加粗并下划线进行显著标识）。' )}
      </div>
      <div className="head-title content-text">
        {_T('个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。' )}
      </div>
      <div className="head-title content-text">
        {_T('除另有约定外，本政策所用定义与《用户服务协议》中的定义具有相同的涵义。' )}
      </div>
      <div className="head-title tips">
        <span>
          <strong>{_T('第二部分 隐私政策' )}</strong>
        </span>
      </div>
      <div className="head-title content-text">
        {_T('本政策将帮助您了解如下内容：' )}
      </div>
      <div className="head-title content-text">
        {_T('第一条 我们如何收集和使用您的个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('第二条 我们如何使用Cookie和同类技术' )}
      </div>
      <div className="head-title content-text">
        {_T('第三条 我们如何共享、转让、公开披露您的个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('第四条 我们如何存储您的个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('第五条 我们如何保护您的个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('第六条 我们如何处理未成年人的个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('第七条 您如何管理您的个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('第八条 本政策如何更新' )}
      </div>
      <div className="head-title content-text">
        {_T('第九条 如何联系我们' )}
      </div>
      <div className="head-title tips-two">
        <span>
          <strong> {_T('第一条【我们如何收集和使用您的个人信息】' )}</strong>
        </span>
      </div>
      <div className="head-title content-text">
        {_T('在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：' )}
      </div>
      <div className="head-title content-text">
        {_T('1、为实现向您提供我们产品及/或服务的基础功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；' )}
      </div>
      <div className="head-title content-text">
        {_T('2、为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基础功能' )}
      </div>
      <div className="head-title content-text">
        {_T('我们在此特别提醒您：' )}
      </div>
      <div className="head-title content-text">
        {_T('1、我们致力于打造多样的产品和服务以满足您的需求。因我们可能会向您提供多种产品和服务种类，且不同用户选择使用的具体产品/服务范围存在差异，相应的，基本/附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；' )}
      </div>
      <div className="head-title content-text">
        {_T('2、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过Dana官方客服与我们联系，我们会尽快为您作出解答。' )}
      </div>
      <div className="head-title content-text">
        {_T('3、本政策中所述的Dana及相关服务可能会根据你所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以你所使用的Dana软件及相关服务为准。' )}
      </div>
      <div className="head-title content-text">
        {_T('一、基础功能需要收集和使用的信息' )}
      </div>
      <div className="head-title content-text">
        {_T('（一）注册、登录' )}
      </div>
      <div className="head-title content-text">
        {_T('您在注册账号或登录Dana过程中，需要向我们提交一些必要的信息：您的手机号码、创建的用户名称、昵称、性别。通过注册验证并同意本政策及用户服务协议后将完成账号注册，您将能够在Dana平台上使用发送消息、即时音视频通话、赠送虚拟物品、留言评论等功能。如果您不同意授权或拒绝我们获取上述信息，您将无法在享受上述注册用户的功能和服务。在注册过程中，如果您提供以下额外的信息，将有助于我们为您提供更好的服务和体验：头像、生日、个性签名、兴趣爱好。如果您不提供这些信息，将不会影响本服务的基本业务功能。' )}
      </div>
      <div className="head-title content-text">
        {_T('（二）实名认证' )}
      </div>
      <div className="head-title content-text">
        {_T('当您希望在Dana平台使用实名认证的功能或相关服务时，您需要完成实名身份认证。您同意并授权Dana平台通过您提交的身份证件信息（均属敏感个人信息）来完成具体产品服务所需必要的实名认证。上述信息将仅用于验证用户身份的真实性，Dana平台会采取行业领先的技术来保护您提供的个人信息，并使用加密、限权等方式避免其被用于其他用途（您另行授权许可的事项除外）。' )}
      </div>
      <div className="head-title content-text">
        {_T('如果您不同意我们收集上述信息，您将无法在Dana平台使用实名认证的功能和相关服务，但不影响您使用产品的其他基础功能。' )}
      </div>
      <div className="head-title content-text">
        {_T('（三）浏览、关注' )}
      </div>
      <div className="head-title content-text">
        {_T('您在浏览Dana平台内容的过程中，可以关注您感兴趣的用户。为此，我们会收集您使用Dana时的设备信息（包括设备型号、操作系统版本、设备设置、IMEI/MEID/Android ID/IDFA/IDFV/OAID/MAC地址/IMSI/ICCID/UDID/GUID即设备标识符、设备序列号、设备环境，下同）。' )}
      </div>
      <div className="head-title content-text">
        {_T('（四）信息发布' )}
      </div>
      <div className="head-title content-text">
        {_T('您可以在Dana内发布动态，对其他用户动态内容进行评论、分享。在此过程中，我们会收集您的设备信息、网络访问日志信息和用户日志信息（包括账号、操作时间、操作记录、网络源地址和目标地址、网络源端口、客户端硬件特征、昵称、简介、备注、标识、用户信息发布、分享、评论记录，下同）。' )}
      </div>
      <div className="head-title content-text">
        {_T('当您使用个人标签、交友偏好、动态、声音、头像/照片墙功能时，您上传的文字、图片、语音、视频信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。您可以随时删除这些信息。除非经您自主选择或遵从相关法律法规要求，我们不会对外提供上述信息，或者将其用于该功能以外的其他用途。请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至敏感个人信息，如您选择上传包含个人信息的文字、图片、语音、视频，请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。如果您不同意我们收集这些信息，请不要上传/发布，这不影响您使用产品的其他基础功能。' )}
      </div>
      <div className="head-title content-text">
        {_T('二、附加功能需要收集和使用的信息' )}
      </div>
      <div className="head-title content-text">
        {_T('（一）充值消费功能' )}
      </div>
      <div className="head-title content-text">
        {_T('当您使用Dana充值消费功能时，我们会收集您的充值记录、消费记录信息，以便您查询自己的交易记录，同时尽最大程度保护您的财产、虚拟财产安全。在支付过程中，我们可能会收集您的第三方支付渠道的user ID。上述信息属于敏感信息，但收集上述信息为实现相关功能所必须，否则将无法完成交易。我们无法仅根据该信息获得您的个人财产信息，也不能识别特定自然人身份信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('（二）基于相机/摄像头的附加功能' )}
      </div>
      <div className="head-title content-text">
        {_T('您可在开启相机/摄像头权限后使用拍照、视频直播、视频通话等服务，也可以在拍照等场景中使用闪光灯等辅助设备。在视频通话过程中，我们会收集您的视频通话内容。' )}
      </div>
      <div className="head-title content-text">
        {_T('（三）基于相册（图片库/视频库）的图片/视频访问及上传的附加功能' )}
      </div>
      <div className="head-title content-text">
        {_T('您可以在开启权限后使用相关功能上传您的照片/图片/视频，以实现上传/更换头像、发布/分享动态、与客服沟通提供证明等功能。' )}
      </div>
      <div className="head-title content-text">
        {_T('（四）基于麦克风语音技术的附加服务' )}
      </div>
      <div className="head-title content-text">
        {_T('您可在开启麦克风权限后使用麦克风实现音视频连麦聊天或录制音频。在此过程中，我们会收集您的语音内容。请您知晓，即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标时通过麦克风获取语音信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('（五）搜索' )}
      </div>
      <div className="head-title content-text">
        {_T('您使用搜索服务时，我们会收集您的搜索关键字信息、剪切板，以提供高效的搜索服务。' )}
      </div>
      <div className="head-title content-text">
        {_T('（六）客服争议及处理' )}
      </div>
      <div className="head-title content-text">
        {_T('当您与我们联系或提起投诉、申诉或进行咨询时，为了保障您的帐号及系统安全，我们需要您提供必要的个人信息以核验您的真实用户身份。为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的沟通、通信/通话记录及相关内容（包括帐号信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息）。如您拒绝提供上述信息，我们可能无法及时反馈投诉、申诉或咨询结果。' )}
      </div>
      <div className="head-title content-text">
        {_T('（七）安全保障' )}
      </div>
      <div className="head-title content-text">
        {_T('为了保障软件与服务的安全运行、保护网络安全、预防网络犯罪、识别您的账号异常以及反欺诈目的，我们会收集您的网络访问日志信息和用户日志信息、设备信息、设备所在位置信息（包括IP地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站即传感器信息）、软件版本号、接入网络的方式、类型和状态、运营商、SSID和BSSID、网络质量数据、软件安装列表、正在运行的进程信息、应用程序的总体运行、总体安装使用情况、性能数据、应用来源和其他日志信息（使用时间与频率的细节、设备统计信息、关键操作路径、错误日志、崩溃记录、语言和时区、互联网协议（IP）地址、互联网服务供应商（ISP）、引用/退出页面、操作系统、日期/时间戳和点击流数据）。' )}
      </div>
      <div className="head-title content-text">
        {_T('（八）提供个性化推荐、展示或推送服务' )}
      </div>
      <div className="head-title content-text">
        {_T('为对您的偏好、习惯、位置作特征分析，以便为您提供更适合的定制化服务，我们会收集您的如下信息：' )}
      </div>
      <div className="head-title content-text">
        {_T('1.关注、搜索、浏览、分享等您的操作、使用行为信息 ；' )}
      </div>
      <div className="head-title content-text">
        {_T('2.反馈、发布、点赞、评论、打赏等您主动提供的互动信息会存储在我们的服务器中，因为存储是实现这一功能所必需的；' )}
      </div>
      <div className="head-title content-text">
        {_T('3.获得您明示同意后的设备所在位置信息（IP地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站即传感器信息），GPS位置信息属于敏感信息，拒绝提供该信息仅会使您无法获得基于GPS位置的平台服务，但不影响您正常使用其他功能。您可以通过【我的→设置→隐私设置】选择附近隐身，清除位置信息，显示/隐藏和其他用户间的距离；' )}
      </div>
      <div className="head-title content-text">
        {_T('4.设备运行应用名称、设备运行应用信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('除非取得您授权或法律法规另有规定外，我们不会将上述信息与您在应用程序中提供的任何个人身份信息相结合，以确保不识别到您个人。我们会将上述信息与来自我们其他服务的信息结合，通过程序算法进行特征与偏好分析、基于特征标签进行间接人群画像，用以向您个性化推荐、展示或推送您可能感兴趣的特定聊天室、音视频、用户、动态等信息，或者推送更合适您的特定功能或服务' )}
      </div>
      <div className="head-title content-text">
        {_T('1. 向您展示、推荐或推送与您有更高相关程度的聊天室、音视频；' )}
      </div>
      <div className="head-title content-text">
        {_T('2. 推荐相关的城市、地区的用户、音视频等信息；' )}
      </div>
      <div className="head-title content-text">
        {_T('3. 使用《用户服务协议》约定的范围和方式向您进行商业信息推送和邀约。' )}
      </div>
      <div className="head-title content-text">
        {_T('（九）基于本地存储的附加功能' )}
      </div>
      <div className="head-title content-text">
        {_T('通过开启本地存储权限，实现下载部分文字、图片、视频等内容缓存数据到您的手机存储，以及通过手机存储将您的本地图片、视频等数据上传到Dana。' )}
      </div>
      <div className="head-title content-text">
        {_T('（十）基于通讯录信息的附加功能' )}
      </div>
      <div className="head-title content-text">
        {_T('您可以授权我们获取您的通讯录信息，以用于您查找您的通讯录好友。' )}
      </div>
      <div className="head-title content-text">
        {_T('您可以通过【我的→设置→隐私设置】选择手机通讯录隐身。' )}
      </div>
      <div className="head-title content-text">
        {_T('三、我们可能会申请获取的设备权限' )}
      </div>
      <div className="head-title content-text">
        {_T('我们在提供服务的过程中，为了收集上述信息、实现前述功能，可能需要向您申请部分设备应用权限。这些权限不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。同时请您知悉，我们为业务与产品的功能与安全需要，会使用第三方SDK，您也可能会在我们的产品过程中使用第三方开发的H5页面或小程序，这些第三方也可能会申请或使用相关操作系统权限。' )}
      </div>
      <div className="head-title content-text">
        {_T('可能申请、使用的相关操作系统权限如下：' )}
      </div>
      <div className="head-title tips-two">
        {_T('（一）安卓操作系统应用权限列表' )}
      </div>
      <div className="head-title content-text">
        {_T('1.读取SD卡中的内容（读取存储空间/照片权限）' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：提供读取手机储存空间内数据的功能' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：允许App或小程序读取存储中的图片、文件等内容，主要用于帮助您发布信息，上传头像等图片、文件、在本地记录崩溃日志信息等功能' )}
      </div>
      <div className="head-title content-text">
        {_T('2.写入/删除SD卡中的内容（写入/删除/存储空间/照片权限）' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：提供写入外部储存功能' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：允许App或小程序写入/下载/保存/缓存/修改/删除图片、文件、崩溃日志等信息' )}
      </div>
      <div className="head-title content-text">
        {_T('3.读取手机状态和身份（电话权限、设备权限）' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：提供读取手机设备标识等信息，请您放心该权限无法监听、获取您的任何通话内容与信息' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：读取设备通话状态和识别码，识别设备ID，用于完成音视频、信息展示、账号登录、安全保障等主要功能' )}
      </div>
      <div className="head-title content-text">
        {_T('4.访问大致地理位置信息' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：通过网络位置信息（例如基站和WLAN）获取大致地理位置信息' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：用于完成安全保障服务及基于地理位置的服务（LBS）如：推荐附近的用户、发布作品坐标定位以及小程序需使用相关位置服务等相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('5.访问精确地理位置信息' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：通过全球定位系统（GPS）或网络位置信息（例如基站和WLAN）获取精准地理位置信息' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：用于完成安全保障服务及基于地理位置的服务（LBS）如：推荐附近的用户、发布作品坐标定位以及小程序需使用相关位置服务等相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('6.录音 android.permission.RECORD_AUDIO' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：使用麦克风录制音频' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：用于帮助您完成音视频信息发布、进行直播、语音通话等需要使用该权限的相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('7.拍摄照片和视频 android.permission.CAMERA' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：使用拍摄照片和视频' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：用于帮助您完成音视频信息发布、进行直播、拍照、视频通话等需要使用该权限的相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('8.读取通讯录 android.permission.READ_CONTACTS' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：获取系统中的通讯录信息' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：用于帮助你实现推荐好友等功能' )}
      </div>
      <div className="head-title content-text">
        {_T('9.连接蓝牙设备 BLUETOOTH' )}
      </div>
      <div className="head-title content-text">
        {_T('权限使用说明：允许应用连接蓝牙设备' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的：适配蓝牙设备' )}
      </div>
      <div className="head-title content-text">
        {_T('10.发现并连接蓝牙设备 BLUETOOTH_ADMIN' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：允许应用发现并连接蓝牙设备' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景与目的_适配蓝牙设备' )}
      </div>
      <div className="head-title tips-two">
        {_T('（二）iOS操作系统应用权限列表' )}
      </div>
      <div className="head-title content-text">
        {_T('1.NSPhotoLibraryAddUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：向相册中添加内容' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：允许App写入/下载/保存/修改/删除图片、文件、崩溃日志等信息' )}
      </div>
      <div className="head-title content-text">
        {_T('2.NSPhotoLibraryUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：读取相册中内容' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：允许App读取存储中的图片、文件等内容，主要用于帮助您发布信息等功能' )}
      </div>
      <div className="head-title content-text">
        {_T('3.NSCameraUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：使用摄像头' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：用于帮助您完成音视频信息发布、进行直播、拍照、视频通话等需要使用该权限的相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('4.NSLocationAlwaysUsegeDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：持续获取地理位置' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：用于完成安全保障、推荐信息以及基于地理位置的服务（LBS）相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('5.NSLocationWhenInUseUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：仅App被使用时获取地理位置' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：用于完成安全保障、推荐信息以及基于地理位置的服务（LBS）相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('6.NSLocationAlwaysAndWhenInUseUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：持续和仅App被使用时获取地理位置' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：用于完成安全保障、推荐信息以及基于地理位置的服务（LBS）相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('7.NSContactsUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：读取用户通讯录' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：用于好友推荐' )}
      </div>
      <div className="head-title content-text">
        {_T('8.NSMicrophoneUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：使用麦克风' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：用于帮助您完成音视频信息发布、进行直播、语音通话等需要使用该权限的相关功能' )}
      </div>
      <div className="head-title content-text">
        {_T('9.NSFaceIDUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明_使用面容ID' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：用于面容ID登录' )}
      </div>
      <div className="head-title content-text">
        {_T('10.NSUserTrackingUsageDescription' )}
      </div>
      <div className="head-title content-text">
        {_T('权限功能说明：获取设备标识，以识别设备信息' )}
      </div>
      <div className="head-title content-text">
        {_T('使用场景和目的：仅用于标识设备并保障服务安全与提升浏览体验' )}
      </div>
      <div className="head-title content-text">
        {_T('四、来自第三方的信息' )}
      </div>
      <div className="head-title content-text">
        {_T('（一）第三方帐号授权' )}
      </div>
      <div className="head-title content-text">
        {_T('当您通过第三方账号注册或登录产品，我们将获取您登录所使用的第三方账号的公开信息（包括头像、昵称、性别、年龄），并将该账号与您的产品账号进行绑定。这是为了记住您作为Dana用户的登录身份，以向您提供更优质的产品和/或服务。我们仅会在您授权同意的范围内收集并使用您的个人信息。如果您不同意授权或拒绝我们获取上述信息，您将无法通过第三方账号注册或登录产品，但不影响您正常使用产品的其他功能。' )}
      </div>
      <div className="head-title content-text">
        {_T('在您使用第三方帐号注册或登录后，您的第三方帐号将会与Dana账号进行绑定，但您可以在【我的→设置→帐号与安全】中选择对帐号解绑，或联系Dana站内客服：【我的-在线客服】-输入“人工客服”进行操作。' )}
      </div>
      <div className="head-title content-text">
        {_T('（二）其他用户分享的信息中含有您的信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('五、敏感个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('在提供任何敏感个人信息前，请您清楚考虑该等提供是恰当的并且同意您的敏感个人信息可按本政策所述的目的和方式进行处理。我们会在得到您的同意后收集和使用您的敏感个人信息以实现相关业务功能，并允许您对这些敏感个人信息的收集与使用做出不同意的选择，但是拒绝使用这些信息会影响您使用相关功能。' )}
      </div>
      <div className="head-title content-text">
        {_T('六、征得授权同意的例外' )}
      </div>
      <div className="head-title content-text">
        {_T('根据相关法律法规规定，以下情形中，我们可以在不征得您授权同意的情况下收集、使用一些必要的个人信息：' )}
      </div>
      <div className="head-title content-text">
        {_T('1、与国家安全、国防安全直接相关的；' )}
      </div>
      <div className="head-title content-text">
        {_T('2、与公共安全、公共卫生、重大公共利益直接相关的；' )}
      </div>
      <div className="head-title content-text">
        {_T('3、与犯罪侦查、起诉、审判和判决执行等直接相关的；' )}
      </div>
      <div className="head-title content-text">
        {_T('4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；' )}
      </div>
      <div className="head-title content-text">
        {_T('5、所收集的个人信息是您自行向社会公众公开的；' )}
      </div>
      <div className="head-title content-text">
        {_T('6、从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；' )}
      </div>
      <div className="head-title content-text">
        {_T('7、根据您的要求签订和履行合同所必需的；' )}
      </div>
      <div className="head-title content-text">
        {_T('8、用于维护Dana的产品和/或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；' )}
      </div>
      <div className="head-title content-text">
        {_T('9、为合法的新闻报道所必需的；' )}
      </div>
      <div className="head-title content-text">
        {_T('10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；' )}
      </div>
      <div className="head-title content-text">
        {_T('11、法律法规规定的其他情形' )}
      </div>
      <div className="head-title content-text">
        {_T('请知悉，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的使用无需另行向您通知并征得您的同意。' )}
      </div>
      <div className="head-title content-text">
        {_T('如我们停止运营Dana平台产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。' )}
      </div>
      <div className="head-title tips-two">
        {_T('第二条 【我们如何使用Cookie和同类技术】' )}
      </div>
      <div className="head-title content-text">
        {_T('Cookie和设备信息标识等同类技术是互联网中普遍使用的技术。当你使用Dana及相关服务时，我们可能会使用相关技术向你的设备发送一个或多个Cookie或匿名标识符，以收集、标识你访问、使用本产品时的信息。我们承诺，不会将Cookie 用于本政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：' )}
      </div>
      <div className="head-title content-text">
        {_T('（一）保障产品与服务的安全、高效运转' )}
      </div>
      <div className="head-title content-text">
        {_T('我们可能会设置认证与保障安全性的Cookie或匿名标识符，使我们确认你是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。' )}
      </div>
      <div className="head-title content-text">
        {_T('（二）帮助你获得更轻松的访问体验' )}
      </div>
      <div className="head-title content-text">
        {_T('使用此类技术可以帮助你省去重复你填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。' )}
      </div>
      <div className="head-title content-text">
        {_T('（三）为你推荐、展示、推送你可能感兴趣的内容或用户' )}
      </div>
      <div className="head-title content-text">
        {_T('1.我们可能会利用此类技术了解你的偏好和使用习惯，进行数据分析，以改善产品服务、推荐用户感兴趣的信息或功能。' )}
      </div>
      <div className="head-title content-text">
        {_T('2.我们可能会使用Cookie对浏览活动进行记录，用于向你推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。' )}
      </div>
      <div className="head-title content-text">
        {_T('（四） Cookie的清除' )}
      </div>
      <div className="head-title content-text">
        {_T('大多数浏览器均为用户提供了清除浏览器缓存数据的功能，你可以在浏览器设置功能中进行相应的数据清除操作。如你进行清除，你可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。' )}
      </div>
      <div className='head-title tips-two'>
        {_T('第三条 【我们如何共享、转让、公开披露您的个人信息】' )}
      </div>
      <div className="head-title content-text">
        {_T('（一）共享' )}
      </div>
      <div className="head-title content-text">
        {_T('我们将对您的信息承担保密义务，不会对外共享或提供您的个人信息，但以下情况除外：' )}
      </div>
      <div className="head-title content-text">
        {_T('1.在获取明确同意的情况下共享：获得您的明确同意后，我们将与其分享您的个人信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('2.法定情形下的共享：我们可能会根据法律法规规定、诉讼和争议解决需要，或按行政、司法机关提出的要求，与司法、行政机关共享或提供您的个人信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('3.与关联公司共享：为便于我们基于Dana或关联公司的账号向您提供产品和服务，推荐您可能感兴趣的内容和信息，识别帐号异常，保护Dana或关联公司用户的账号及财产安全，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。' )}
      </div>
      <div className="head-title content-text">
        {_T('4.与授权合作伙伴共享：为了向您提供更完善、优质的产品和服务，我们可能委托授权合作伙伴或接入第三方服务实现部分技术功能（如嵌入代码、插件、SDK等形式）为您提供服务或代表我们履行职能。我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的共享您的信息，上述第三方服务仅能接触到其履行职责所需用户个人信息，并保证将采取行业领先的技术来保护您的个人信息安全。' )}
      </div>
      <div className="head-title content-text">
        {_T('目前，我们的授权合作伙伴包括以下类型：' )}
      </div>
      <div className="head-title content-text">
        {_T('（1）基础服务提供商：包括提供支付、一键登录、消息推送、地理位置定位、反欺诈的合作方，与这些服务提供商的信息共享大多通过SDK方式进行。' )}
      </div>
      <div className="head-title content-text">
        {_T('（2）提供数据服务（包括数据统计、数据分析）的合作伙伴：为维护/改进我们的产品/服务、为您提供更好的内容，我们可能会与提供该服务的指定合作伙伴共享您的相关信息（包括：设备信息、终端型号、地理位置），除非得到您的同意，我们不会与其共享您的个人身份信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('（3）内容安全监测服务提供商：我们可能与特定内容安全监测服务提供商合作进行违规音视频标注和分析，可能会与这些服务提供商共享直播流信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('（4）提供开播或直播推流服务的合作伙伴：当我们与提供开播或直播推流服务的第三方平台进行合作时，我们可能共享用户昵称、排行榜、打赏信息等聊天室已公开的用户数据。' )}
      </div>
      <div className="head-title content-text">
        {_T('（二）转让' )}
      </div>
      <div className="head-title content-text">
        {_T('我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：' )}
      </div>
      <div className="head-title content-text">
        {_T('1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向第三方转让您的个人信息；' )}
      </div>
      <div className="head-title content-text">
        {_T('2.在涉及合并、收购、破产清算时，如涉及个人信息转让，我们将要求受让方继续受本政策约束，否则我们将要求受让方向您重新征求授权同意。' )}
      </div>
      <div className="head-title content-text">
        {_T('（三）公开披露' )}
      </div>
      <div className="head-title content-text">
        {_T('我们仅在下列情形下，公开披露您的个人隐私信息：' )}
      </div>
      <div className="head-title content-text">
        {_T('1.征得您明确的授权同意或基于您的主动选择；' )}
      </div>
      <div className="head-title content-text">
        {_T('2.基于国家法律法规的规定而对外披露；' )}
      </div>
      <div className="head-title content-text">
        {_T('3.如果我们确定您出现违反法律法规或严重违反Dana平台相关协议及规则的情况，或为保护Dana平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露您的个人信息。' )}
      </div>
      <div className="head-title tips-two">
        {_T('第四条 【我们如何存储您的个人信息】' )}
      </div>
      <div className="head-title content-text">
        {_T('（一）存储地点' )}
      </div>
      <div className="head-title content-text">
        {_T('为了向全世界的用户提供服务，我们在全球开展业务。您特此授权我们在我们运营的任何国家和地区（包括以下地区）传输，存储和使用您的数据：' )}
      </div>
      <div className="head-title content-text">
        {_T('新加坡共和国。为此，我们将确保您数据的安全性，保护措施将不低于您所在国的保护标准。' )}
      </div>
      <div className="head-title content-text">
        {_T('（二）存储期限' )}
      </div>
      <div className="head-title content-text">
        {_T('我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：' )}
      </div>
      <div className="head-title content-text">
        {_T('1.为遵守适用的法律法规规定；' )}
      </div>
      <div className="head-title content-text">
        {_T('2.为遵守法院判决、裁定或其他法律程序的规定；' )}
      </div>
      <div className="head-title content-text">
        {_T('3.为遵守政府机关或法定授权组织的要求；' )}
      </div>
      <div className="head-title content-text">
        {_T('4.为执行平台协议或本政策、维护社会公共利益，保护Dana及关联公司、其他用户或雇员的人身安全或其他合法权益所合理必需的用途。' )}
      </div>
      <div className="head-title content-text">
        {_T('在您的个人信息超出保留期间后，我们会删除您的个人信息，或对其进行匿名化处理' )}
      </div>
      <div className="head-title tips-two">
        {_T('第五条 【我们如何保护您的个人信息】' )}
      </div>
      <div className="head-title content-text">
        {_T('1.我们非常重视您个人信息的安全，并努力采取一切合理的安全措施（包括技术方面和管理方面）来保障您的个人隐私信息安全，防止您提供的个人隐私信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。' )}
      </div>
      <div className="head-title content-text">
        {_T('2.我们将使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。' )}
      </div>
      <div className="head-title content-text">
        {_T('3.我们会建立安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，与他们签署保密协议，监控他们的操作情况，并适时对数据和技术进行安全审计，保障您的个人信息安全。' )}
      </div>
      <div className="head-title content-text">
        {_T('4.我们制定了严密的应急处理方案，并定期组织演练，以确保在突发状况下能够将损失减少到最低。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。' )}
      </div>
      <div className="head-title content-text">
        {_T('5.我们设立了个人信息保护专职部门，在公司内部实施内控管理。' )}
      </div>
      <div className="head-title content-text">
        {_T('6.我们在保障您个人隐私信息安全的同时也建议您提高自我个人隐私信息防范意识，勿将您的个人隐私信息通过互联网透露给他人，勿随意点开他人所发的链接。' )}
      </div>
      <div className="head-title tips-two">
        {_T('第六条 【我们如何处理未成年人的个人信息】' )}
      </div>
      <div className="head-title content-text">
        {_T('Dana的产品和服务面向成年人。若您是未成年人，建议您不要使用我们的产品和/或服务，若您一定要使用我们的产品和/或服务，您应在监护人的陪同下阅读本政策，并应确保已征得您的监护人同意后使用我们的服务并向我们提供您的信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们。' )}
      </div>
      <div className="head-title content-text">
        {_T('对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策第九条“如何联系我们”章节中的联系方式与我们联系。我们将根据国家相关法律法规及本政策的规定保护未成年人用户信息的保密性及安全性。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。' )}
      </div>
      <div className="head-title content-text">
        {_T('请注意，我们禁止14周岁以下的儿童注册、使用我们的产品和/或服务。若我们识别到用户为14周岁以下的儿童，或者其他用户分享的信息中含有儿童的个人信息，则该儿童的个人信息同时适用本政策以及《儿童隐私保护声明》。' )}
      </div>
      <div className="head-title content-text">
        {_T('若您是儿童的监护人，应当仔细阅读本政策、产品具体的隐私保护指引（如有）和《儿童隐私保护声明》，如您对您所监护的儿童的个人信息保护有相关疑问或权利请求时，请通过《儿童隐私保护声明》中所披露的联系方式与我们联系。我们会在合理的时间内处理并回复您' )}
      </div>
      <div className="head-title tips-two">
        {_T('第七条 【您如何管理您的个人信息】' )}
      </div>
      <div className="head-title content-text">
        {_T('我们非常重视你对个人信息的管理，并尽全力保护你对于你个人信息的查询、访问、修改、删除、撤回同意授权、注销帐号、投诉举报以及设置隐私功能的相关权利，以使你有能力保障你的隐私和信息安全。' )}
      </div>
      <div className="head-title content-text">
        {_T('（一）改变或撤回授权范围' )}
      </div>
      <div className="head-title content-text">
        {_T('1.改变或撤回敏感权限设置' )}
      </div>
      <div className="head-title content-text">
        {_T('您可以在设备本身操作系统中关闭精确地理位置信息、通讯录、摄像头、麦克风、相册权限、日历权限，改变同意范围或撤回你的授权。撤回授权后我们将不再收集与这些权限相关信息。' )}
      </div>
      <div className="head-title content-text">
        {_T('2.改变或撤回同意授权' )}
      </div>
      <div className="head-title content-text">
        {_T('您可以通过本政策第九条“如何联系我们”章节中的联系方式与我们联系，改变或撤回同意授权。' )}
      </div>
      <div className="head-title content-text">
        {_T('3.改变或撤回授权的信息处理' )}
      </div>
      <div className="head-title content-text">
        {_T('特定的业务功能和服务将需要你的信息才能得以完成，当你撤回同意或授权后，我们无法继续为你提供撤回同意或授权所对应的功能和服务，也不再处理你相应的个人信息。但你撤回同意或授权的决定，不会影响我们此前基于你的授权而开展的个人信息处理。' )}
      </div>
      <div className="head-title content-text">
        {_T('（二）访问、删除、更正/修改你的个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('1.查询访问、更正/修改、删除个人帐号信息' )}
      </div>
      <div className="head-title content-text">
        {_T('你可以查询、访问你的头像、昵称、性别、生日、职业、声音、签名、个人标签、交友偏好，你可以在【修改个人资料】进行查询、访问、更正/修改。' )}
      </div>
      <div className="head-title content-text">
        {_T('2.查询访问、更正/修改、删除其他个人信息' )}
      </div>
      <div className="head-title content-text">
        {_T('a.进入【动态】中访问、删除你发布的动态' )}
      </div>
      <div className="head-title content-text">
        {_T('b.进入【关注】可以访问、查询关注的帐号信息，在关注列表点击相应帐号后的“已关注”按钮（如有）或进入相应关注帐号主页可以点击右上角取消关注该帐号' )}
      </div>
      <div className="head-title content-text">
        {_T('c.进入【帐号与安全】访问、更正/修改、绑定手机号、第三方帐号、安全手机号' )}
      </div>
      <div className="head-title content-text">
        {_T('d.出于安全性和身份识别的考虑，你可能无法自主修改提交的某些信息；如你确有必要修改该类信息，请你通过本政策第九条“如何联系我们”章节中的联系方式联系我们，我们将尽快审核所涉问题，并由专人验证你的用户身份后及时予以回复。' )}
      </div>
      <div className="head-title content-text">
        {_T('3.控制信息可见范围' )}
      </div>
      <div className="head-title content-text">
        {_T('a.进入【黑名单】控制他人是否可以与你通讯、是否可以查看你的帐号内容' )}
      </div>
      <div className="head-title content-text">
        {_T('b.进入【手机通讯录隐身】中控制他人是否通过手机通讯录发现你' )}
      </div>
      <div className="head-title content-text">
        {_T('c.进入【显示距离】中控制他人是否可以看到你们之间的距离。' )}
      </div>
      <div className="head-title content-text">
        {_T('当我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。' )}
      </div>
      <div className="head-title content-text">
        {_T('（三）注销您的账号' )}
      </div>
      <div className="head-title content-text">
        {_T('您可以通过以下方式申请注销您的账号：' )}
      </div>
      <div className="head-title content-text">
        {_T('自助申请注销：【账号与安全】-【注销账号】进行申请。' )}
      </div>
      <div className="head-title content-text">
        {_T('您需要满足Dana账号注销条件即可申请注销，Dana平台人员在审核通过后由用户确认即可实现注销。你知悉并理解，注销帐号的行为是不可逆的行为，当你注销帐号后，我们将删除有关你的相关信息或进行匿名化处理，但法律法规另有规定的除外。' )}
      </div>
      <div className="head-title content-text">
        {_T('账号注销后您已发布的所有内容将转为匿名发布，如需删除内容，请在申请注销前自行处理。' )}
      </div>
      <div className="head-title content-text">
        {_T('注销账号并不代表账号注销前的行为和相关责任得到任何形式的豁免或减轻。' )}
      </div>
      <div className="head-title content-text">
        {_T('（四）约束信息系统自动决策' )}
      </div>
      <div className="head-title content-text">
        {_T('在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害Dana商业秘密或其他用户权益、社会公共利益、国家利益的前提下做出合理解释。' )}
      </div>
      <div className="head-title content-text">
        {_T('（五）投诉举报' )}
      </div>
      <div className="head-title content-text">
        {_T('你可以按照我们公示的制度进行投诉或举报。如果你认为你的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，你可以通过本政策第九条“如何联系我们”章节中的联系方式与我们联系。' )}
      </div>
      <div className="head-title content-text">
        {_T('（六）响应您的上述请求' )}
      </div>
      <div className="head-title content-text">
        {_T('在您提出上述请求时，我们可能会要求您进行身份验证，以保障账号的安全。若您拒绝提供相应证明材料，我们将无法响应您的请求。' )}
      </div>
      <div className="head-title content-text">
        {_T('请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。' )}
      </div>
      <div className="head-title content-text">
        {_T('在以下情形中，按照法律法规要求，我们将无法响应您的请求：' )}
      </div>
      <div className="head-title content-text">
        {_T('1.与国家安全、国防安全、国家利益有关的；' )}
      </div>
      <div className="head-title content-text">
        {_T('2.与公共安全、公共卫生、重大公共利益有关的；' )}
      </div>
      <div className="head-title content-text">
        {_T('3.与犯罪刑事侦查、起诉、立案、审判和执行判决等有关的；' )}
      </div>
      <div className="head-title content-text">
        {_T('4.有充分证据表明表明您存在主观恶意或滥用权利的；' )}
      </div>
      <div className="head-title content-text">
        {_T('5.响应您的请求将导致其他个人、组织的合法权益受到严重损害的；' )}
      </div>
      <div className="head-title content-text">
        {_T('6.涉及商业秘密的；' )}
      </div>
      <div className="head-title content-text">
        {_T('7.法律规定的其他情形。' )}
      </div>
      <div className="head-title tips-two">
        {_T('第八条 【本政策如何更新】' )}
      </div>
      <div className="head-title content-text">
        {_T('为保证您能够获得更好的服务并应平台业务调整以及未来发展，本政策也会与时俱进随之更新。但在更新的同时，我们会以单独、明显的方式获取您的授权，否则我们不会削减你依据当前生效的本隐私政策所应享受的权利。' )}
      </div>
      <div className="head-title content-text">
        {_T('我们在应用程序、官方网站更新版本后或平台发出公告后以合理、适当、明显的方式提醒您相关内容的更新，以便您能更快了解您权利的更迭。您也可以进入【联系我们-隐私政策】查看本政策的全部内容。' )}
      </div>
      <div className="head-title content-text">
        {_T('对于重大变更，我们还会提供更为显著的通知方式（我们会通过包括但不限于邮件、短信、站内消息、公告、首页或在浏览页面做特别提示等方式，来向您表达政策的更新内容）。' )}
      </div>
      <div className="head-title content-text">
        {_T('本政策所指的重大变更包括但不限于：' )}
      </div>
      <div className="head-title content-text">
        {_T('1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；' )}
      </div>
      <div className="head-title content-text">
        {_T('2.我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；' )}
      </div>
      <div className="head-title content-text">
        {_T('3.个人信息共享、转让或公开披露的主要对象发生变化；' )}
      </div>
      <div className="head-title content-text">
        {_T('4.您参与个人信息处理方面的权利及其行使方式发生重大变化；' )}
      </div>
      <div className="head-title content-text">
        {_T('5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；' )}
      </div>
      <div className="head-title content-text">
        {_T('6.个人信息安全影响评估报告表明存在高风险时。' )}
      </div>
      <div className="head-title content-text">
        {_T('若您不同意修改后的隐私政策，您有权并应立即停止使用Dana的产品和服务。如果您继续使用Dana的产品或服务，则视为您接受Dana对本政策相关条款所做的修改。' )}
      </div>
      <div className="head-title tips-two">
        {_T('第九条 【如何联系我们】' )}
      </div>
      <div className="head-title content-text">
        {_T('如果您对本政策存有任何疑问、意见或建议，可以通过如下方式与我们联系：' )}
      </div>
      <div className="head-title content-text">
        {_T('电子邮件：cs@Dana.chat' )}
      </div>
      <div className="head-title content-text">
        {_T('我们将尽快审核所涉问题，并在验证你的用户身份后的七个工作日内回复。' )}
      </div>
      <div className="head-title content-text">
        {_T('本协议之效力、解释、变更、执行与争议解决均适用新加坡共和国法律。因本协议产生之争议，均应依照新加坡法律予以处理。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，由Dana平台经营者与您协商解决。' )}
      </div>
        <div className="h-[100px]"></div>
      </div>
    </div>
  );
}
